<template>
  <div class="tradgoods-list">
    <Row>
      <Col :xs="24"
           :sm="24">
      <Form :model="formItem"
            ref="formItem"
            :inline="true"
            action="javascript:void(0)">
        <FormItem>
          <Cascader :data="cateList"
                    v-model="selectCate1"
                    @on-change="cateSelect1"
                    :style="{'width':'300px'}"
                    placeholder="分类"></Cascader>
        </FormItem>
        <FormItem>
          <Select v-model="formItem.status"
                  clearable
                  style="width:100px"
                  placeholder="状态">
            <Option v-for="item in statusList"
                    :value="item.id"
                    :key="item.id">{{ item.name }}</Option>
          </Select>
        </FormItem>
        <FormItem>
          <Select v-model="formItem.is_pos"
                  clearable
                  style="width:100px"
                  placeholder="推荐">
            <Option v-for="item in posList"
                    :value="item.id"
                    :key="item.id">{{ item.name }}</Option>
          </Select>
        </FormItem>
        <FormItem>
          <Input v-model="formItem.key"
                 clearable
                 placeholder="输入商品名称查找..."></Input>
        </FormItem>
        <FormItem>
          <Button type="primary"
                  @click="renderTable(1)">查找</Button>
        </FormItem>
        <FormItem>
          <Button @click="showModel()"
                  type="success"
                  class="f-l">添加</Button>
        </FormItem>
      </Form>
      </Col>
    </Row>
    <Table border
           :columns="list"
           :data="tablelist"
           :loading="dataloading"></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page ref="listPage"
              :total="pages.total"
              :current="pages.page"
              :page-size="pages.size"
              show-elevator
              show-total
              @on-change="changePage()"></Page>
      </div>
    </div>
    <Drawer :title="title"
            v-model="showModalStatus"
            width="1200"
            :mask-closable="false"
            :styles="styles">
      <Tabs v-model="step">
        <TabPane label="基础信息"
                 name="firstStep">
          <Form :model="goods"
                :label-width="80"
                ref="goodsValidate"
                :rules="goodsValidate">
            <Row>
              <Col span="12">
              <FormItem label="商品分类"
                        label-position="top"
                        prop="selectCate">
                <Cascader :data="cateList"
                          v-model="selectCate"
                          @on-change="cateSelect"></Cascader>
              </FormItem>
              </Col>
              <Col span="12">
              <FormItem label="品牌"
                        label-position="top">
                <Select v-model="goods.brand_id"
                        clearable
                        filterable
                        placeholder="选择品牌">
                  <Option v-for="item in brandList"
                          :value="item.id"
                          :key="item.id">{{item.name}}</Option>
                </Select>
              </FormItem>
              </Col>
            </Row>

            <Row>
              <Col span="12">
              <FormItem label="商品标题"
                        label-position="top"
                        prop="title">
                <Input v-model="goods.title"
                       placeholder="商品标题">></Input>
              </FormItem>
              </Col>
              <Col span="12">
              <FormItem label="发票信息"
                        label-position="top">
                <Input v-model="goods.invoice_title"
                       placeholder="货物名称；规格型号；单位；数量"></Input>
              </FormItem>
              </Col>
            </Row>
            <FormItem label="商品规格"
                      label-position="top">
              <Row>
                <Col span="5">
                <Input v-model="goodsSpec"
                       placeholder="颜色/尺寸/重量"></Input>
                </Col>
                <Col span="5">
                <Input v-model="goodsSpecItem"
                       placeholder="红黄蓝/1CM*2CM/1KG"></Input>
                </Col>
                <Col span="14">
                <Button style="float:left"
                        type="info"
                        @click="addSpec(goods.id)">添加</Button>
                <Alert style="float:left"
                       type="error">若填写商品规格，则上方的开票信息不必填写，只需填写按规格对应的开票信息</Alert>
                </Col>
              </Row>
            </FormItem>
            <!--规格下拉选开始-->
            <Card style="margin-top:20px;margin-left: 80px;"
                  v-if="goodsSpecType.length !=0 ">
              <Form>
                <FormItem v-for="(spec) in goodsSpecType"
                          :key="spec.id"
                          :label="spec.name">
                  <Row>
                    <tag v-for="item in spec.goodspecitem"
                         :key="item.id"
                         style="margin-right:10px;height:30px;line-height:30px;">{{item.item}}</tag>
                    <Button type="info"
                            style="margin-right:10px;margin-left: 10px;"
                            @click="editSpec(spec)">编辑</Button>
                    <Button type="error"
                            style="margin-right:10px;"
                            @click="deleteSpec(spec)">删除</Button>
                  </Row>
                </FormItem>
              </Form>
            </Card>
            <!--规格下拉选结束-->
            <!--规格列表开始-->
            <Card style="margin-top:20px;margin-left: 80px;"
                  v-for="(goodsSpec,specindex) in goodsSpecList"
                  :key="goodsSpec.good_spec_key">
              <Row style="margin-top:10px;">
                <Col span="22">
                <tag v-for="(spec,index) in goodsSpec.specList"
                     :key="spec.name"
                     style="margin-right:10px;height:30px;line-height:30px;"
                     :color="getTagColor(index)">{{spec.name+':'+spec.item}}</tag>
                </Col>
              </Row>
              <Row style="margin-top:10px;">
                <Col span="6"
                     style="padding-right:30px;">
                <Input v-model="goodsSpec.good_store"
                       style="margin-left:6px"
                       placeholder="请输入库存">
                <span slot="prepend">库存</span>
                </Input>
                </Col>
                <Col span="6"
                     style="padding-right:30px;">
                <Input v-model="goodsSpec.good_price"
                       style="margin-left:6px"
                       placeholder="请输入价格">
                <span slot="prepend">价格</span>
                </Input>
                </Col>
                <Col span="6"
                     style="padding-right:30px;">
                <Input v-model="goodsSpec.invoice_title"
                       style="margin-left:6px"
                       placeholder="货物名称；规格型号；单位；数量">
                <span slot="prepend">发票信息</span>
                </Input>
                </Col>
                <Col span="6"
                     style="padding-right:30px;">
                <Input v-model="goodsSpec.agent_fx_money"
                       style="margin-left:6px"
                       placeholder="请输入金额">
                <span slot="prepend">代理商户分销金额</span>
                </Input>
                </Col>
                <Col span="4"
                     style="padding-right:30px;padding-top:10px;">
                <upload-thumb v-model="goodsSpec.thumb"
                              :ref="'goodsUploadthumb'+specindex"
                              :defaultList="goodsSpec.thumblist"
                              :autoCropWidth="320"
                              :autoCropHeight="320"
                              :defaultTip="'建议图片尺寸:320*320'"></upload-thumb>
                </Col>
              </Row>
            </Card>
            <FormItem v-for="attr in goodsAttrList"
                      :key="attr.id"
                      :label="'*'+ attr.name"
                      label-position="top"
                      style="margin-top: 10px">
              <Input v-model="attr.detail"></Input>
            </FormItem>

            <Row style="margin-top: 20px;">
              <Col span="8">
              <FormItem label="生产地"
                        label-position="top">
                <Input v-model="goods.place"></Input>
              </FormItem>
              </Col>
              <Col span="8">
              <FormItem label="库存"
                        label-position="top">
                <Input v-model="goods.store"
                       :readonly="isBlockGoods"></Input>
              </FormItem>
              </Col>
              <Col span="8">
              <FormItem label="默认价格"
                        label-position="top"
                        prop="prices">
                <Input v-model="goods.prices"></Input>
              </FormItem>
              </Col>
            </Row>
            <FormItem label="关键字"
                      label-position="top"
                      prop="keyword">
              <Input v-model="goods.keyword"></Input>
            </FormItem>
            <FormItem label="描述"
                      label-position="top"
                      prop="describe">
              <Input type="textarea"
                     v-model="goods.describe"
                     :rows="3"
                     placeholder="请输入描述" />
            </FormItem>
            <Row>
              <Col span="8">
              <FormItem label="上架时间"
                        prop="lasttime">
                <DatePicker v-model="goods.lasttime"
                            format="yyyy-MM-dd HH:mm:ss"
                            placeholder="上架时间"
                            style="width: 200px"
                            @on-change="changeDateOne"></DatePicker>
              </FormItem>
              </Col>
              <Col span="8">
              <FormItem label="下架时间"
                        prop="lowertime">
                <DatePicker v-model="goods.lowertime"
                            format="yyyy-MM-dd HH:mm:ss"
                            placeholder="下架时间"
                            style="width: 200px"
                            @on-change="changeDateTwo"></DatePicker>
              </FormItem>
              </Col>
              <Col span="8">
              <FormItem label="排序"
                        label-position="top">
                <Input v-model="goods.sort"></Input>
              </FormItem>
              </Col>
            </Row>

            <FormItem label="封面图"
                      prop="thumb">
              <upload-thumb v-model="goods.thumb"
                            ref="uploadthumb"
                            :defaultList="thumblist"
                            :autoCropWidth="320"
                            :autoCropHeight="320"
                            :defaultTip="'图片格式:jpg、jpeg、png、gif,建议图片尺寸:320*320'"></upload-thumb>
            </FormItem>
            <FormItem label="相册"
                      prop="album">
              <upload-thumb v-model="goods.album"
                            ref="uploadthumbTwo"
                            :defaultList="thumblistTwo"
                            :autoCropWidth="750"
                            :autoCropHeight="750"
                            :defaultTip="'图片格式:jpg、jpeg、png、gif,建议图片尺寸:750*750'"></upload-thumb>
            </FormItem>
            <FormItem label="内容"
                      prop="content">
              <UEditor v-model="goods.content"
                       ref="editContent"></UEditor>
            </FormItem>
            <Row>
              <Col span="12">
              <FormItem label="选择匠人"
                        label-position="top"
                        prop="tradesman_id">
                <Select ref="tradselect"
                        v-model="goods.from_uuid"
                        clearable
                        filterable
                        placeholder="选择匠人"
                        @on-change="ChangeTemplateList">
                  <Option v-for="item in trandList"
                          :value="item.uuid"
                          :key="item.id">{{item.nickname}}</Option>
                </Select>
              </FormItem>
              </Col>
              <Col span="12">
              <FormItem label="邮费模板"
                        label-position="top">
                <Select v-model="goods.ship_template_id"
                        clearable
                        filterable
                        placement="top"
                        placeholder="选择模板">
                  <Option :value="0"
                          :key="0">全国包邮</Option>
                  <Option v-for="item in TemplateList"
                          :value="item.id"
                          :key="item.id">{{item.title}}</Option>
                </Select>
              </FormItem>
              </Col>
            </Row>
            <Row v-if="isztpoint">
              <Col span="6">
              <FormItem label="是否自提"
                        label-position="top">
                <RadioGroup v-model="goods.is_ziti">
                  <Radio label="0">否</Radio>
                  <Radio label="1">是</Radio>
                </RadioGroup>
              </FormItem>
              </Col>
            </Row>
          </Form>
        </TabPane>
        <TabPane label="营销信息"
                 name="secondStep">
          <Form :model="goods"
                :label-width="80">
            <Row>
              <Col span="6">
              <FormItem label="是否支持7天无理由退货"
                        label-position="top">
                <RadioGroup v-model="goods.is_seven_return">
                  <Radio label="0">否</Radio>
                  <Radio label="1">是</Radio>
                </RadioGroup>
              </FormItem>
              </Col>
              <Col span="6">
              <FormItem label="是否云支付"
                        label-position="top">
                <RadioGroup v-model="goods.is_cloud">
                  <Radio label="0">否</Radio>
                  <Radio label="1">是</Radio>
                </RadioGroup>
              </FormItem>
              </Col>
              <Col span="6">
              <FormItem label="是否推荐"
                        label-position="top">
                <RadioGroup v-model="goods.is_pos">
                  <Radio label="0">否</Radio>
                  <Radio label="1">是</Radio>
                </RadioGroup>
              </FormItem>
              </Col>
              <Col span="6">
              <FormItem label="是否热卖"
                        label-position="top">
                <RadioGroup v-model="goods.is_hot">
                  <Radio label="0">否</Radio>
                  <Radio label="1">是</Radio>
                </RadioGroup>
              </FormItem>
              </Col>
            </Row>

            <Row>
              <Col span="6">
              <FormItem label="是否新品"
                        label-position="top">
                <RadioGroup v-model="goods.is_new">
                  <Radio label="0">否</Radio>
                  <Radio label="1">是</Radio>
                </RadioGroup>
              </FormItem>
              </Col>
              <Col span="6">
              <FormItem label="是否自营"
                        label-position="top">
                <RadioGroup v-model="goods.is_self">
                  <Radio label="0">否</Radio>
                  <Radio label="1">是</Radio>
                </RadioGroup>
              </FormItem>
              </Col>
              <Col span="6">
              <FormItem label="是否定制"
                        label-position="top">
                <RadioGroup v-model="goods.is_made">
                  <Radio label="0">否</Radio>
                  <Radio label="1">是</Radio>
                </RadioGroup>
              </FormItem>
              </Col>
              <Col span="6">
              <FormItem label="是否代理商户分销"
                        label-position="top">
                <RadioGroup v-model="goods.is_fx"
                            @on-change="agentFx">
                  <Radio label="0">否</Radio>
                  <Radio label="1">是</Radio>
                </RadioGroup>
              </FormItem>
              </Col>
            </Row>
            <Row>
              <Col span="12">
              <FormItem label="代理商户分销比例"
                        label-position="top">
                <Input v-model="goods.agent_fx"
                       :disabled="isable"
                       style="width:100px"
                       @on-keyup="sum()">
                <span slot="append">%</span>
                </Input>
              </FormItem>
              </Col>
              <Col span="12">
              <FormItem label="代理商户分销金额"
                        label-position="top">
                <Input v-model="goods.agent_fx_money"
                       :disabled="isable"
                       style="width:100px"
                       @on-keyup="sum1()">
                </Input>
              </FormItem>
              </Col>
            </Row>
            <Row>
              <Col span="12">
              <Alert type="warning"
                     style="width:960px">
                <p>* 二级分销是一个让人可以帮你一起卖货的销售激励功能，通过设置商品的销售提成来激励分销员线上销售，迅速扩张线上销售额。您只需要每一笔订单支付给分销商一部分佣金，分销商就愿意为您带货。每件商品的销售提成由您自由设置。</p>
                <p style="padding-top:5px">
                  商品实际收入=商品销售金额—平台抽佣（销售金额*10%）—二级分销提成
                </p>
              </Alert>
              </Col>
            </Row>
          </Form>
        </TabPane>
      </Tabs>
      <div class="demo-drawer-footer">
        <Button style="margin-right: 8px"
                @click="showModalStatus = false;step='firstStep'">取消</Button>
        <Button type="primary"
                @click="creategoods('goodsValidate')">提交</Button>
      </div>
    </Drawer>
    <Modal v-model="showEditSpec"
           title="修改规格"
           @on-ok="editSpecDone"
           @on-cancel="editSpecCancel"
           :loading="editSpecLoading">
      <Form :model="goods"
            :label-width="60"
            ref="goodsValidate1"
            :rules="goodsValidate">
        <FormItem label="名称"
                  label-position="top">
          <Input v-model="editSpecDetail.name"></Input>
        </FormItem>
        <FormItem label="规格项"
                  label-position="top">
          <Row v-for="(item,index) in editSpecDetail.goodspecitem">
            <Col span="10">
            <Input v-model="item.item"></Input>
            </Col>
            <Col span="6">
            <Button type="primary"
                    shape="circle"
                    icon="ios-trash-outline"
                    @click="deleteSpecItem(item,index)" />
            </Col>
          </Row>
        </FormItem>
      </Form>
      <Button type="primary"
              @click="addNewSpec()">添加新规格项</Button>
    </Modal>
  </div>
</template>

<script>
import UploadThumb from "../common/thumb";
import UEditor from "../common/ueditor";
import uploadthumbTwo from "../common/thumb";

export default {
  name: "tradgoods-list",
  data () {
    const validateSelectCate = (rule, value, callback) => {
      if (this.selectCateId === "") {
        callback(new Error("请输入商品分类"));
      } else {
        callback();
      }
    };
    const validateTradesmanId = (rule, value, callback) => {
      if (
        this.goods.from_uuid == "" ||
        this.goods.from_uuid == null ||
        this.goods.from_uuid == undefined
      ) {
        callback(new Error("请选择匠人"));
      } else {
        callback();
      }
    };
    const validateThumb = (rule, value, callback) => {
      if (this.$refs["uploadthumb"].uploadList.length == 0) {
        callback(new Error("请上传封面图"));
      } else {
        callback();
      }
    };
    const validateThumbTwo = (rule, value, callback) => {
      if (this.$refs["uploadthumbTwo"].uploadList.length == 0) {
        callback(new Error("请上传相冊"));
      } else {
        callback();
      }
    };
    const validateContent = (rule, value, callback) => {
      if (this.goods.content == "") {
        callback(new Error("内容必须填写"));
      } else {
        callback();
      }
    };
    const validatePirces = (rule, value, callback) => {
      if (
        this.goods.prices == "" ||
        this.goods.prices == null ||
        this.goods.prices == undefined
      ) {
        callback(new Error("价格必须填写"));
      } else {
        callback();
      }
    };
    const validateStore = (rule, value, callback) => {
      if (
        this.goods.store == "" ||
        this.goods.store == null ||
        this.goods.store == undefined
      ) {
        callback(new Error("库存必须填写"));
      } else {
        callback();
      }
    };
    return {
      step: "firstStep",
      fx: "0",
      editSpecLoading: true, // 修改规格loading
      isztpoint: false,
      styles: {
        height: "calc(100% - 55px)",
        overflow: "auto",
        paddingBottom: "53px",
        position: "static"
      },
      isBlockGoods: false,
      tempId: "",
      goodsSpec: "", //添加的规格
      goodsSpecItem: "", //添加的规格名称
      goodsSpecType: [], //规格列表
      goodsSpecDetail: [], //商品规格数据
      specList: [], //规格展示列表
      specDataList: [], //规格数据展示列表
      showEditSpec: false, //是否显示编辑规格页面
      editSpecDetail: {},
      goodsAttrList: [],
      FareTypeStatus: false,
      goods: {
        title: "",
        keyword: "",
        describe: "",
        content: "",
        thumb: "",
        album: "",
        is_ziti: "0",
        ship_template_id: 0,
        is_cloud: "0",
        is_pos: "0",
        is_hot: "0",
        is_new: "0",
        is_self: "0",
        is_made: "0",
        is_fx: "0",
        agent_fx: 0,
        is_seven_return: "0",
        is_blockchain: "0",
        sort: "0",
        from_uuid: "",
        agent_fx_money: 0
      },
      isable: true,
      editor: {
        ifno: ""
      },
      isClear: false,
      loading: true,
      dataloading: true,
      thumblist: [],
      thumblistTwo: [],
      cateList: [], // 请求分类
      selectCate: [],
      selectCate1: [],
      selectCateId: "",
      selectCateId1: "",
      datePic: [],
      brandList: [],
      trandList: [],
      statusList: [
        { id: 1, name: "正常" },
        { id: 0, name: "下架" }
      ],
      platList: [
        { id: 0, name: "普通" },
        { id: 1, name: "云支付" }
      ],
      hotList: [
        { id: 0, name: "否" },
        { id: 1, name: "是" }
      ],
      posList: [
        { id: 0, name: "否" },
        { id: 1, name: "是" }
      ],
      blockList: [
        { id: 0, name: "否" },
        { id: 1, name: "是" }
      ],
      pages: {
        page: 1,
        size: 10,
        total: 0
      },
      title: "",
      formItem: {
        key: ""
      },
      list: [
        {
          title: "Id",
          key: "good_id",
          fixed: "left",
          width: 90
        },
        {
          title: "标题",
          key: "good_title",
          minWidth: 200,
          render: (h, params) => {
            return h("div", [
              h("span", {}, params.row.good_title),
              h(
                "span",
                {
                  style: {
                    marginLeft: "5px",
                    color: "#a94442"
                  }
                },
                "图"
              )
            ]);
          }
        },
        {
          title: "匠人",
          key: "nickname",
          minWidth: 150
        },
        {
          title: "分类",
          key: "good_cate",
          minWidth: 150,
          render: (h, params) => {
            return h("div", [h("span", {}, params.row.good_cate)]);
          }
        },
        {
          title: "库存",
          key: "good_store",
          minWidth: 80
        },
        {
          title: "销量",
          key: "good_sales",
          minWidth: 80
        },
        {
          title: "状态",
          key: "good_status",
          minWidth: 80
        },
        {
          title: "修改时间",
          key: "good_updated",
          minWidth: 150
        },
        {
          title: "操作",
          key: "action",
          width: 200,
          align: "left",
          fixed: "right",
          render: (h, params) => {
            if (params.row.good_status == "在售") {
              return h("div", [
                h(
                  "Button",
                  {
                    style: {
                      marginRight: "8px"
                    },
                    props: {
                      type: "primary",
                      size: "small"
                    },
                    on: {
                      click: () => {
                        this.detail(params.row.good_id);
                      }
                    }
                  },
                  "编辑"
                ),
                h(
                  "Button",
                  {
                    style: {
                      marginRight: "8px"
                    },
                    props: {
                      type: "warning",
                      size: "small"
                    },
                    on: {
                      click: () => {
                        params.row.good_status == "在售"
                          ? this.editStatus(params.row.good_id, 0)
                          : this.editStatus(params.row.good_id, 1);
                      }
                    }
                  },
                  params.row.good_status == "在售" ? "下架" : "上架"
                )
              ]);
            } else {
              return h("div", [
                h(
                  "Button",
                  {
                    style: {
                      marginRight: "8px"
                    },
                    props: {
                      type: "primary",
                      size: "small"
                    },
                    on: {
                      click: () => {
                        this.detail(params.row.good_id);
                      }
                    }
                  },
                  "编辑"
                ),
                h(
                  "Button",
                  {
                    style: {
                      marginRight: "8px"
                    },
                    props: {
                      type: "warning",
                      size: "small"
                    },
                    on: {
                      click: () => {
                        params.row.good_status == "在售"
                          ? this.editStatus(params.row.good_id, 0)
                          : this.editStatus(params.row.good_id, 1);
                      }
                    }
                  },
                  params.row.good_status == "在售" ? "下架" : "上架"
                ),
                h(
                  "Button",
                  {
                    style: {
                      marginRight: "8px"
                    },
                    props: {
                      type: "error",
                      size: "small"
                    },
                    on: {
                      click: () => {
                        this.remove(params.row.good_id);
                      }
                    }
                  },
                  "删除"
                )
              ]);
            }
          }
        }
      ],
      tablelist: [],
      TemplateList: [],
      showModalStatus: false,
      goodsValidate: {
        title: [{ required: true, message: "名称必须填写", trigger: "blur" }],
        keyword: [
          { required: true, message: "关键词必须填写", trigger: "blur" }
        ],
        describe: [
          { required: true, message: "描述必须填写", trigger: "blur" }
        ],
        content: [
          { required: true, validator: validateContent, trigger: "change" }
        ],
        selectCate: [
          { required: true, validator: validateSelectCate, trigger: "change" }
        ],
        thumb: [
          { required: true, validator: validateThumb, trigger: "change" }
        ],
        album: [
          { required: true, validator: validateThumbTwo, trigger: "change" }
        ],
        prices: [
          { required: true, validator: validatePirces, trigger: "blur" }
        ],
        tradesman_id: [
          {
            required: true,
            validator: validateTradesmanId,
            trigger: "change"
          }
        ],
        // store: [{ required: true, validator: validateStore, trigger: "blur" }],
        lasttime: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (this.goods.lasttime == "") {
                callback(new Error("上架时间必须填写"));
              } else {
                callback();
              }
            },
            trigger: "change"
          }
        ],
        lowertime: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (this.goods.lowertime == "") {
                callback(new Error("下架时间必须填写"));
              } else {
                callback();
              }
            },
            trigger: "change"
          }
        ]
      },
      id: 0,
      goodsSpecList: []
    };
  },
  created: function () {
    this.from_uuid = this.$route.query.from_uuid;
    this.getTableList();
    this.getBrandList();
    this.getTrandList();
    this.getCate();
  },
  components: {
    UploadThumb,
    UEditor,
    uploadthumbTwo
  },

  methods: {
    ChangeTemplateList: function (val) {
      this.getFareTemplate(val);
      this.$api.tradesman.zitipointlist({ merchant_uuid: val }).then(res => {
        if (res.code == 200 && res.result > 0) {
          this.isztpoint = true;
        } else {
          this.isztpoint = false;
        }
      });
    },
    //获取邮费模板
    getFareTemplate: function (uuid) {
      this.$api.tradesman.shiptemplatelist({ merchant_uuid: uuid, page: 1, size: 10 }).then(res => {
        if (res.code == 200) {
          this.TemplateList = res.result.list;
        }
      });
      return;
    },
    getTableList: function () {
      this.$api.goods
        .list({
          page: this.pages.page,
          size: this.pages.size,
          from_uuid: this.from_uuid,
          is_platprice: "0"
        })
        .then(res => {
          this.dataloading = false;
          if (res.code == 200) {
            this.tablelist = res.result.list;
            this.pages.total = res.result.total;
            this.$Message.success(res.msg);
            // 同步筛选条件
            this.renderTable();
          }
        });
      return;
    },
    getBrandList () {
      this.$api.goodbrand.list().then(res => {
        if (res.code == 200) {
          this.brandList = res.result.list;
        }
      });
    },
    getTrandList () {
      this.$api.tradesman.list({ page: 1, size: 10000 }).then(res => {
        if (res.code == 200) {
          this.trandList = res.result.list;
        }
      });
    },
    // 获取分类getCate
    getCate: function () {
      this.$api.goodcate.list().then(res => {
        if (res.code == 200) {
          var total = res.result;
          var arr = new Array();
          for (var i in total) {
            var di = {
              value: total[i].f_id,
              label: total[i].f_name,
              children: []
            };
            for (var j in total[i].childs) {
              di.children.push({
                value: total[i].childs[j].s_id,
                label: total[i].childs[j].s_name
              });
            }
            arr.push(di);
          }

          this.cateList = arr;
        }
      });
      return;
    },
    cateSelect: function (value, selectedData) {
      if (
        selectedData != "" &&
        selectedData != undefined &&
        selectedData != null
      ) {
        var end = selectedData[selectedData.length - 1];
        this.selectCateId = end.value;
        this.goodsAttrList = [];
        this.getAttrData(this.selectCateId);
      }
    },
    cateSelect1: function (value, selectedData) {
      var end = selectedData[selectedData.length - 1];
      if (end) {
        this.selectCateId1 = end.value;
      } else {
        this.selectCateId1 = "";
      }
    },
    //规格
    //删除规格
    deleteSpec (spec) {
      var params = { good_spec_id: spec.id };
      this.$Modal.confirm({
        title: "警告",
        content: "<p>此操作会删除所有规格，且不可恢复，三思而后行...</p>",
        onOk: () => {
          this.$api.goodspec.remove(params).then(res => {
            if (res.code == 200) {
              var list = this.goodsSpecType;
              for (let i = 0; i < list.length; i++) {
                const goodsSpec = list[i];
                if (goodsSpec.id == spec.id) {
                  list.splice(i, 1);
                }
              }
              this.goodsSpecType = list;
              this.goodsSpec = "";
              this.goodsSpecDetail = [];
              this.specList = [];
              this.showAllSepc()
            }
          });
        }
      });
    },
    //编辑规格
    editSpec (spec) {
      this.showEditSpec = true;
      this.editSpecDetail = spec;
    },
    editSpecDone () {
      var items = [];
      for (
        let index = 0;
        index < this.editSpecDetail.goodspecitem.length;
        index++
      ) {
        const specItem = this.editSpecDetail.goodspecitem[index];
        if (
          specItem.item &&
          specItem.item != undefined &&
          specItem.item != ""
        ) {
          items.push(specItem.item);
        }
      }
      // this.showEditSpec = false
      var good_id = this.goods.id;
      if (good_id == null || good_id == undefined || good_id == "") {
        good_id = this.tempId;
      }
      var params = {
        good_id: good_id,
        good_spec_id: this.editSpecDetail.id,
        goodspec: this.editSpecDetail.name,
        goodspecitem: items
      };
      var that = this;
      this.$api.goodspec.edit(params).then(res => {
        if (res.code == 200) {
          this.editSpecLoading = false;

          this.$nextTick(() => {
            that.editSpecLoading = true;
            that.showEditSpec = false;
          });
        }
        this.$api.goodspec.specDetail({ gid: good_id }).then(res => {
          if (res.code == 200) {
            that.goodsSpecType = res.result;
            that.showAllSepc();
          }
        });
      });
    },
    editSpecCancel () {
      if (
        this.goods.id == null ||
        this.goods.id == 0 ||
        this.goods.id == undefined
      ) {
        this.goods.id = this.tempId;
      }
      this.$api.goodspec.specDetail({ gid: this.goods.id }).then(res => {
        if (res.code == 200) {
          if (res.result != null) {
            this.goodsSpecType = res.result;
            this.showAllSepc();
          }

        }
      });
    },
    addNewSpec () {
      var detail = this.editSpecDetail;
      var items = detail.goodspecitem;
      if (items == null || items == undefined) {
        items = [];
      }
      items.push({ item: "" });
      detail.goodspecitem = items;
      this.editSpecDetail = detail;
    },
    deleteSpecItem (item, index) {
      var detail = this.editSpecDetail;
      var items = detail.goodspecitem;
      if (items.length <= 1) {
        return;
      }
      items.splice(index, 1);
      detail.goodspecitem = items;
      this.editSpecDetail = detail;
    },
    //添加规格
    addSpec (id) {
      if (
        this.goodsSpec == null ||
        this.goodsSpec == undefined ||
        this.goodsSpec == "" ||
        this.goodsSpecItem == null ||
        this.goodsSpecItem == undefined ||
        this.goodsSpecItem == ""
      ) {
        this.$toast("规格和规格项不能为空");
        return;
      }
      if (id == null) {
        id = this.tempId;
      }
      var params = {
        gid: id,
        goodspec: this.goodsSpec,
        goodspecitem: this.goodsSpecItem
      };
      this.$api.goodspec.create(params).then(res => {
        if (res.code == 200) {
          this.goodsSpecType = res.result; //
          this.goodsSpec = null;
          this.goodsSpecItem = null;
          this.showAllSepc();
        }
      });
    },
    // 改变分销比例
    agentFx: function (val) {
      // 返回的是 lable值
      if (val == "1") {
        this.isable = false;
      } else {
        this.isable = true;
      }
    },
    changeDateTwo (val) {
      this.goods.lowertime = val;
    },
    changeDateOne (val) {
      this.goods.lasttime = val;
    },
    // 展开添加
    showModel () {
      this.title = "添加商品";
      this.isBlockGoods = false;
      this.goods = {
        title: "",
        keyword: "",
        describe: "",
        content: "",
        thumb: "",
        album: "",
        is_ziti: "0",
        ship_template_id: 0,
        from_uuid: "",
        is_cloud: "0",
        is_pos: "0",
        is_hot: "0",
        is_new: "0",
        is_self: "0",
        is_made: "0",
        is_fx: "0",
        is_seven_return: "0",
        agent_fx: 0,
        sort: "0",
        is_blockchain: "0",
        agent_fx_money: 0
      };
      this.isable = true;
      this.thumblist = new Array();
      this.thumblistTwo = new Array();
      this.selectCateId = "";
      this.selectCate = [];
      this.goodsAttrList = [];
      (this.goodsSpec = ""), //添加的规格
        (this.goodsSpecItem = ""), //添加的规格名称
        (this.goodsSpecType = []), //规格列表
        (this.goodsSpecDetail = []), //商品规格数据
        (this.specList = []), //规格展示列表
        (this.specDataList = []),
        this.$refs["goodsValidate"].resetFields();
      // this.$refs["editContent"].editor.txt.html("");
      this.$refs["editContent"].message = "";
      this.$refs.tradselect.clearSingleSelect();
      var d1 = new Date();
      var d2 = new Date();
      d2.setFullYear(d1.getFullYear() + 1);
      this.goods.lasttime = this.formatDate(d1, "yyyy-MM-dd hh:mm:ss");
      this.goods.lowertime = this.formatDate(d2, "yyyy-MM-dd hh:mm:ss");
      this.showModalStatus = !this.showModalStatus;
      this.tempId = (new Date().getTime() / 1000).toFixed();
      this.goodsSpecList = [];
    },
    //计算分销
    sum () {
      var goodprice = this.goods.prices == undefined || this.goods.prices == "" ? 0 : this.goods.prices;
      //计算分成
      var agentfx = this.goods.agent_fx;
      if (agentfx * 1 > 100) {
        this.$Message.error("分销比例不能大于100");
        return;
      }
      var fx = parseFloat(agentfx) / 100;
      var real = goodprice;
      if (agentfx != "") {
        this.goods.agent_fx_money = parseFloat(real * fx).toFixed(2);
      } else {
        this.goods.agent_fx_money = 0;
      }
    },
    //计算分销
    sum1 () {
      var goodprice = this.goods.prices;
      this.goods.agent_fx = parseFloat((this.goods.agent_fx_money / this.goods.prices) * 100).toFixed(2);
      if (this.goods.agent_fx_money * 1 > this.goods.prices * 1) {
        this.$Message.error("设置的代理商户分销金额太大");
        return;

      }
    },
    // 详情
    detail (id) {
      let that = this;
      this.title = "编辑商品";
      this.goodsAttrList = [];
      (this.goodsSpec = ""), //添加的规格
        (this.goodsSpecItem = ""), //添加的规格名称
        (this.goodsSpecType = []), //规格列表
        (this.goodsSpecDetail = []), //商品规格数据
        (this.specList = []), //规格展示列表
        (this.specDataList = []),
        (this.thumblist = new Array());
      this.thumblistTwo = new Array();
      this.$refs["goodsValidate"].resetFields();
      this.showModalStatus = true;
      this.isBlockGoods = false;
      this.$refs.tradselect.clearSingleSelect();
      this.$api.goods.detail({ good_id: id }).then(res => {
        this.goods = res.result;
        this.goods.is_cloud = res.result.goodset.is_cloud.toString();
        this.goods.is_pos = res.result.goodset.is_pos.toString();
        this.goods.is_hot = res.result.goodset.is_hot.toString();
        this.goods.is_new = res.result.goodset.is_new.toString();
        this.goods.is_self = res.result.goodset.is_self.toString();
        this.goods.is_made = res.result.goodset.is_made.toString();
        this.goods.is_fx = res.result.goodset.is_fx.toString();
        this.goods.is_ziti = res.result.goodset.is_ziti == null ? "0" : res.result.goodset.is_ziti.toString();
        this.getFareTemplate(this.goods.from_uuid);
        this.goods.ship_template_id = res.result.goodset.ship_template_id == null ? 0 : res.result.goodset.ship_template_id;
        if (res.result.ztpointcount > 0) {
          this.isztpoint = true;
        } else {
          this.isztpoint = false;
        }
        if (this.goods.is_fx == "1") {
          this.isable = false;
        } else {
          this.isable = true;
        }
        this.goods.agent_fx = res.result.goodset.agent_fx.toString();
        this.goods.agent_fx_money = res.result.goodset.agent_fx_money;
        this.goods.is_blockchain = res.result.goodset.is_blockchain.toString();
        if (this.goods.is_blockchain == "1") {
          this.isBlockGoods = true;
        }
        this.goods.is_seven_return = res.result.goodset.is_seven_return.toString();
        this.goodsSpecType = res.result.goodspec;
        this.goodsSpecList = res.result.specList;
        // this.showAllSepc();
        this.editSpecCancel();
        //处理富文本图片
        var good_content = res.result.content;
        var content = good_content.replace(
          /(<img [^>]*src=['"])([^'"]+)([^>]*)/g,
          function (match, $1, $2, $3) {
            if (/^http/.test($2)) {
              return $1 + $2 + $3;
            } else {
              return $1 + that.$publicData.ossUrl + $2 + $3;
            }
          }
        );
        this.$refs["editContent"].message = content;
        //处理thumb
        if (this.goods.thumb != null && this.goods.thumb != "") {
          this.thumblist.push({
            name: this.goods.thumb,
            url: this.goods.thumb,
            status: "finished"
          });
        }
        if (this.goods.album != null && this.goods.album.length > 0) {
          for (var s in this.goods.attrShow) {
            this.thumblistTwo.push({
              name: this.goods.attrShow[s],
              url: this.goods.attrShow[s],
              status: "finished"
            });
          }
        }
        // console.log("this.thumblistTwo", this.thumblistTwo);
        var selectCate = [];
        for (let i = 0; i < this.cateList.length; i++) {
          const cate = this.cateList[i];
          if (cate.value == this.goods.goodcate.id) {
            selectCate.push(cate.value);
            this.selectCateId = cate.value;
            break;
          } else {
            var success = false;
            for (let j = 0; j < cate.children.length; j++) {
              const subCate = cate.children[j];
              if (subCate.value == this.goods.goodcate.id) {
                selectCate.push(cate.value);
                selectCate.push(subCate.value);
                this.selectCateId = subCate.value;
                success = true;
                break;
              }
            }
            if (success) {
              break;
            }
          }
        }
        this.selectCate = selectCate;
        this.getAttrData(this.goods.goodcate.id);
        this.sum();
        // console.log(this.goods);
      });
    },
    //商品属性
    getAttrData (id) {
      this.$api.goodattr.list({ cate_id: id, page: 1, size: 999 }).then(res => {
        if (res.code == 200) {
          var attrList = res.result.list == null ? [] : res.result.list;
          var goodsAttr = this.goods.goodattrdata;
          if (goodsAttr == null || goodsAttr == undefined) {
            goodsAttr = [];
          }
          for (let i = 0; i < attrList.length; i++) {
            var attr = attrList[i];
            for (let j = 0; j < goodsAttr.length; j++) {
              const g = goodsAttr[j];
              attr.detail = "";
              if (
                attr.id == g.good_attr_id &&
                g.good_attr_value != null &&
                g.good_attr_value != "null"
              ) {
                let a = g.good_attr_value; //eval('(' +g.good_attr_value + ')');
                a = this.unicode2Ch(a);
                attr.detail = a.replace(/\"/g, "");
                break;
              }
            }
          }
          this.goodsAttrList = attrList;
        }
      });
    },
    // 字符转码
    unicode2Ch (str) {
      if (!str) {
        return;
      }
      // 控制循环跃迁
      var len = 1;
      var result = "";
      // 注意，这里循环变量的变化是i=i+len 了
      for (var i = 0; i < str.length; i = i + len) {
        len = 1;
        var temp = str.charAt(i);
        if (temp == "\\") {
          // 找到形如 \u 的字符序列
          if (str.charAt(i + 1) == "u") {
            // 提取从i+2开始(包括)的 四个字符
            var unicode = str.substr(i + 2, 4);
            // 以16进制为基数解析unicode字符串，得到一个10进制的数字
            result += String.fromCharCode(parseInt(unicode, 16).toString(10));
            // 提取这个unicode经过了5个字符， 去掉这5次循环
            len = 6;
          } else {
            result += temp;
          }
        } else {
          result += temp;
        }
      }
      return result;
    },
    // 添加
    creategoods (name) {
      if (this.goodsSpecList && this.goodsSpecList.length > 0) {
        for (let i = 0; i < this.goodsSpecList.length; i++) {
          var goodsSpec = this.goodsSpecList[i];
          var key = "goodsUploadthumb" + i.toString();
          var upload = null;
          if (this.$refs[key]) {
            if (this.$refs[key].length > 0) {
              upload = this.$refs[key][0];
            } else {
              upload = this.$refs[key];
            }
          }
          if (upload.uploadList.length > 0) {
            goodsSpec.thumb = upload.uploadList[0].url;
          }
        }
      }
      this.goods.goodspec = [];
      this.goods.goodspecprice = [];
      this.goods.specList = [];
      this.goods.content = this.$refs["editContent"].message;
      if (this.goods.agent_fx_money * 1 > this.goods.prices * 1) {
        this.$Message.error("设置的代理商户分销金额太大");
        return;
      }
      this.$refs[name].validate(valid => {
        // console.log(valid);
        if (valid) {
          if (this.$refs["uploadthumb"].uploadList.length > 0) {
            this.goods.thumb = this.$refs["uploadthumb"].uploadList[0].url;
          } else {
            this.goods.thumb = null;
          }
          // return
          //相册
          if (this.$refs["uploadthumbTwo"].uploadList.length > 0) {
            var finalAttrs = "";
            var tList = this.$refs["uploadthumbTwo"].uploadList;
            for (var s in tList) {
              finalAttrs = finalAttrs + tList[s].url + ",";
            }
            if (finalAttrs != "") {
              this.goods.album = finalAttrs.substring(0, finalAttrs.length - 1);
            }
          }
          if (this.selectCateId) {
            this.goods.cate_id = this.selectCateId;
          }
          //商品规格
          if (this.goodsSpecList.length > 0) {
            this.goods.spec_item = this.goodsSpecList;
          }
          var good_attr = []; //商品属性
          for (let i = 0; i < this.goodsAttrList.length; i++) {
            const attr = this.goodsAttrList[i];
            var good_a = {
              good_attr_id: attr.id,
              good_attr_value: attr.detail
            };
            good_attr.push(good_a);
          }
          this.goods.good_attr = good_attr;
          if (this.goods.lasttime instanceof Date) {
            this.goods.lasttime = this.formatDate(
              this.goods.lasttime,
              "yyyy-MM-dd hh:mm:ss"
            );
          }
          if (this.goods.lowertime instanceof Date) {
            this.goods.lowertime = this.formatDate(
              this.goods.lowertime,
              "yyyy-MM-dd hh:mm:ss"
            );
          }
          if (
            this.goods.id == null ||
            this.goods.id == 0 ||
            this.goods.id == undefined
          ) {
            this.goods.id = this.tempId;
            //新建商品
            this.$api.goods.create(this.goods).then(res => {
              if (res.code == 200) {
                this.getTableList();
                this.showModalStatus = false;
                this.step = "firstStep";
              }
              this.goods.id = null;
              this.dataloading = false;
              this.$nextTick(() => {
                this.dataloading = true;
              });
            });
          } else {
            //编辑商品
            this.$api.goods.edit(this.goods).then(res => {
              if (res.code == 200) {
                this.getTableList();
                this.showModalStatus = false;
                this.step = "firstStep";
              }
              this.dataloading = false;
              this.$nextTick(() => {
                this.dataloading = true;
              });
            });
          }
        } else {
          this.$Message.error("请检查输入的信息是否正确！");
          this.dataloading = false;
          this.$nextTick(() => {
            this.dataloading = true;
          });
        }
      });
    },
    // 上下架
    editStatus: function (id, index) {
      this.$api.goods.status({ id: id, status: index }).then(res => {
        if (res.code == 200) {
          this.$Message.success(res.msg);
          this.getTableList();
        }
      });
    },
    // 删除
    remove: function (id) {
      // 弹出确认框
      this.$Modal.confirm({
        title: "警告",
        content: "<p>此操作不可恢复，三思而后行...</p>",
        onOk: () => {
          this.$api.goods.remove({ id: id }).then(res => {
            if (res.code == 200) {
              this.$Message.success(res.msg);
              this.getTableList(1);
            }
          });
        }
      });
    },
    // 翻页
    changePage () {
      this.pages.page = this.$refs["listPage"].currentPage;
      this.renderTable();
    },
    // 筛选
    renderTable: function (name) {
      if (name == 1) {
        this.pages.page = 1;
      }
      this.dataloading = true;
      var ps = {
        is_platprice: 0,
        from_uuid: this.from_uuid,
        key: this.formItem.key,
        page: this.pages.page,
        size: this.pages.size,
        status: this.formItem.status,
        is_pos: this.formItem.is_pos,
        cate_id: this.selectCateId1
      };
      this.$api.goods.list(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    },
    formatDate (tt, fmt) {
      if (null == tt || "" == tt) return "";
      var date = new Date(tt);
      let o = {
        "M+": date.getMonth() + 1, // 月份
        "d+": date.getDate(), // 日
        "h+": date.getHours(), // 小时
        "m+": date.getMinutes(), // 分
        "s+": date.getSeconds(), // 秒
        S: date.getMilliseconds() // 毫秒
      };
      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(
          RegExp.$1,
          (date.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
      }
      for (var k in o) {
        if (new RegExp("(" + k + ")").test(fmt)) {
          fmt = fmt.replace(
            RegExp.$1,
            RegExp.$1.length === 1
              ? o[k]
              : ("00" + o[k]).substr(("" + o[k]).length)
          );
        }
      }
      return fmt;
    },
    getTagColor (index) {
      var color = "red";
      switch (index % 3) {
        case 1:
          color = "blue";
          break;
        case 2:
          color = "green";
          break;
        default:
          break;
      }
      return color;
    },
    change (val) {
      // console.log(this.goods.content);
    },
    showAllSepc () {
      var arr = [];
      for (let i = 0; i < this.goodsSpecType.length; i++) {
        const specType = this.goodsSpecType[i];
        for (let j = 0; j < specType.goodspecitem.length; j++) {
          var spec = specType.goodspecitem[j];
          spec.name = specType.name;
        }
        arr.push(specType.goodspecitem);
      } // 处理成二维数组

      var specList = [];
      if (arr.length > 0) {
        specList = this.runSpecTypeList(arr);
      }
      var goodsSpecList = [];
      for (let i = 0; i < specList.length; i++) {
        const specArr = specList[i];
        var specName = "";
        var specId = "_";
        var temp = {
          invoice_title: "",
          good_price: 0,
          good_store: 0,
          specList: [],
          good_spec_key: "",
          good_spec_name: "",
          thumb: null,
          thumblist: []
        };
        if (Array.isArray(specArr)) {
          for (let j = 0; j < specArr.length; j++) {
            const cateSpec = specArr[j];
            specId += cateSpec.id;
            specId += "_";
            if (specName == "") {
              specName += cateSpec.name + ":" + cateSpec.item;
            } else {
              specName += " " + cateSpec.name + ":" + cateSpec.item;
            }
            var s = { name: cateSpec.name, item: cateSpec.item };
            temp.specList.push(s);
            temp.good_spec_key = specId;
            temp.good_spec_name = specName;
            for (let k = 0; k < this.goodsSpecList.length; k++) {
              var goodsSpec = this.goodsSpecList[k];
              if (goodsSpec.good_spec_key == temp.good_spec_key) {
                temp = goodsSpec;
                break;
              }
            }
            temp.thumblist = [];
            if (temp.thumb != null && temp.thumb != "") {
              temp.thumblist.push({
                name: temp.thumb,
                url: temp.thumb,
                status: "finished"
              });
            }
          }
        } else {
          specId += specArr.id;
          specId += "_";
          if (specName == "") {
            specName += specArr.name + ":" + specArr.item;
          } else {
            specName += " " + specArr.name + ":" + specArr.item;
          }
          var s = { name: specArr.name, item: specArr.item };
          temp.specList.push(s);
          temp.good_spec_key = specId;
          temp.good_spec_name = specName;
          for (let k = 0; k < this.goodsSpecList.length; k++) {
            var goodsSpec = this.goodsSpecList[k];
            if (goodsSpec.good_spec_key == temp.good_spec_key) {
              temp = goodsSpec;
              break;
            }
          }
          // console.log('tmpgoodsSpec', temp)
          temp.thumblist = [];
          if (temp.thumb != null && temp.thumb != "") {
            temp.thumblist.push({
              name: temp.thumb,
              url: temp.thumb,
              status: "finished"
            });
          }

        }
        // console.log('thumbe', temp)
        goodsSpecList.push(temp);
      }
      // console.log(goodsSpecList)
      this.goodsSpecList = goodsSpecList;
      console.log("this.goodsSpecList", this.goodsSpecList);
      this.$forceUpdate();
    },
    runSpecTypeList (array) {
      // 笛卡尔积算法
      //这里array只有一个元素的时候会处理成对象
      //if( array.length < 2 ) return array[0] || [];
      return [].reduce.call(array, function (col, set) {
        var res = [];
        col.forEach(function (c) {
          set.forEach(function (s) {
            var t = [].concat(Array.isArray(c) ? c : [c]);

            t.push(s);
            res.push(t);
          });
        });
        return res;
      });
    },
    addNewSpec_y () {
      var specName = "";
      var specId = "_";
      var temp = {
        invoice_title: "",
        good_price: "",
        good_store: 0,
        specList: [],
        good_spec_key: "",
        good_spec_name: ""
      };
      for (let i = 0; i < this.goodsSpecType.length; i++) {
        const cateSpec = this.goodsSpecType[i];
        if (
          cateSpec.selectItemId == null ||
          cateSpec.selectItemId == undefined ||
          cateSpec.selectItemId == ""
        ) {
          this.$Message.error("规格" + cateSpec.name + "未选择");
          return;
        }
        for (let j = 0; j < cateSpec.goodspecitem.length; j++) {
          const spec = cateSpec.goodspecitem[j];
          if (spec.id == cateSpec.selectItemId) {
            specId += spec.id;
            specId += "_";
            if (specName == "") {
              specName += cateSpec.name + ":" + spec.item;
            } else {
              specName += " " + cateSpec.name + ":" + spec.item;
            }
            var s = { name: cateSpec.name, item: spec.item };
            temp.specList.push(s);
            temp.good_spec_key = specId;
            temp.good_spec_name = specName;
            break;
          }
        }
      }
      for (let i = 0; i < this.goodsSpecList.length; i++) {
        const gs = this.goodsSpecList[i];
        if (gs.good_spec_key == temp.good_spec_key) {
          this.$Message.error("规格" + temp.good_spec_name + "已存在");
          return;
        }
      }
      this.goodsSpecList.push(temp);
      // console.log(this.goodsSpecList);
    },
    removeSpec (specindex) {
      this.goodsSpecList.splice(specindex, 1);
    }
  }
};
</script>

<style>
.demo-drawer-footer {
  width: 100%;
  height: 50px;
  position: absolute;
  bottom: 0;
  left: 0;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  background: #fff;
}
</style>
